import { GridColDef } from "@mui/x-data-grid";
import pathRoutes from "../../../routes/pathRoutes";
import { Edit, Remove, View } from "@app/components/Actions";
import { useUser } from "@services/servicesGenericsTables";

export const usersColumns: GridColDef[] = [
  {
    field: "name",
    headerName: "Nombre",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "last_name",
    headerName: "Apellido",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "email",
    headerName: "Correo electrónico",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "roles",
    headerName: "Roles",
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "username",
    headerName: "Nombre de usuario",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "mobile_phone",
    headerName: "Teléfono móvil",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "phone",
    headerName: "Teléfono fijo",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "address",
    headerName: "Dirección",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "city",
    headerName: "Ciudad",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "province",
    headerName: "Provincia",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "postal_code",
    headerName: "Código postal",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "country",
    headerName: "País",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "dni",
    headerName: "DNI",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "workstation",
    headerName: "Cargo",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    align: "center",
    flex: 1,
    sortable: false,
    renderCell: (params: any) => (
      <>
        <View to={`${pathRoutes.ADMIN_USUARIOS}/ver/${params.id}`} />
        <Edit to={`${pathRoutes.ADMIN_USUARIOS}/editar/${params.id}`} />
        <Remove onRemove={() => useUser.getState().remove(params.row.id)} />
      </>
    ),
  },
];
